import { useState } from "react";
import { Lock } from "lucide-react";
import { API } from "@/lib/api";

export const LockPreviewButton = () => {
  const [busy, setBusy] = useState(false);
  const lock = async () => {
    setBusy(true);
    try {
      await fetch(`${API}/gate/logout`, { method: "POST", credentials: "include" });
    } finally {
      window.location.assign("/");
    }
  };
  return (
    <button
      type="button"
      onClick={lock}
      disabled={busy}
      data-testid="lock-preview-btn"
      className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-stone-300 text-stone-600 hover:text-stone-900 hover:border-stone-500 transition-colors disabled:opacity-60"
    >
      <Lock className="w-3 h-3" aria-hidden /> Lock preview
    </button>
  );
};
